/// <reference path="../typings/index.d.ts" />
namespace App {
  export class TopSniperDiego {
    private urlUpdateFiltro: string = null
    public configuracoes: any = null
    public topCartasMomento: ICartaTopSniper[] = [];

    constructor(urlUpdateFiltro: string) {
      this.urlUpdateFiltro = urlUpdateFiltro

      this.configuracoes = {
        id_filtro_automatico_cx_baixo: 65977,
        id_filtro_automatico_cx_medio_1: 65979,
        id_filtro_automatico_cx_medio_2: 65980,
        id_filtro_automatico_cx_alto: 65981,
        //IMPORTANTE: preco_compra_fixo_filtro_dinamico tem que ser menor que preco_condicional_entrar_top_cartas
        lucro_condicional_entrar_top_cartas: 10000, // lucro geral obtido com a carta para podendo salvar o filtro
        //preco_condicional_entrar_top_cartas: 30000, // preco de venda minimo da carta para entrar podendo salvar o filtro
        preco_compra_carta_especial_cx_baixo: 15000, // preco de compra que será salvo no filtro
        preco_compra_carta_especial_cx_medio: 40000, // preco de compra que será salvo no filtro
        preco_compra_carta_especial_cx_alto: 70000, // preco de compra que será salvo no filtro
        preco_variacao_filtro_automatico_1: 5, // variação de preço que será salvo no filtro
        preco_variacao_filtro_automatico_2: 6, // variação de preço que será salvo no filtro
        usar_filtro_qualidade: false
      };
    }

    public async validarRegrasUrlCarregada(urlAtual: string): Promise<string> {

      return null
    }

    public iniciarRecarregamento() {
      window.location.href = 'https://futsniperweb.com.br/admin/top-sniper'
    }

    /**
     * Condição para as cartas certas que considero importantes está em minha análise
     * @param objTopCarta
     */
    public condicaoTopCartasImportantes(objTopCarta: ICartaTopSniper) {
      // CONDIÇÃO: ter 1 ou mais novas cartas caindo, o lucro total tem que ser maior do que 70000
      if (objTopCarta.quantidade_mais >= 2 && objTopCarta.lucro > this.configuracoes.lucro_condicional_entrar_top_cartas) {
        this.topCartasMomento.push(objTopCarta)
      }
    }

    public async prepararTopCartas() {
      console.log("TOP_CARTAS DIEGO::", this.topCartasMomento);
      this.topCartasMomento = await Promise.all(this.topCartasMomento.map(async (item: ICartaTopSniper) => ({ ...item, player_info: await TopSniperUtil.filtrarPlayerInfoOrg(item.nome, item.resource_id) })));
      this.topCartasMomento.sort((a: any, b: any) => b.lucro - a.lucro);
      console.log('TOP_CARTAS_ORDER DIEGO::', this.topCartasMomento);
      this.metodoTopCartasAdminDiego();
    }

    public async processarTopCartasPilotoPrincipalPorQualidade(cartasEspeciaisCxMedio: ICartaTopSniper[], cartasEspeciaisCxAlto: ICartaTopSniper[]) {
      if (cartasEspeciaisCxMedio.length) {
        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: this.configuracoes.id_filtro_automatico_cx_medio_1,
          variar: this.configuracoes.preco_variacao_filtro_automatico_2,
          maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_medio ? this.configuracoes.preco_compra_carta_especial_cx_medio : TopSniperUtil.getMenorPreco(cartasEspeciaisCxMedio[0].valor_all),
          maskedDefId: [cartasEspeciaisCxMedio[0].asset_id],
          quality: "SP"
        })
        if (cartasEspeciaisCxMedio.length > 1) {
          TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
            id: this.configuracoes.id_filtro_automatico_cx_medio_2,
            variar: this.configuracoes.preco_variacao_filtro_automatico_2,
            maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_medio ? this.configuracoes.preco_compra_carta_especial_cx_medio : TopSniperUtil.getMenorPreco(cartasEspeciaisCxMedio[1].valor_all),
            maskedDefId: [cartasEspeciaisCxMedio[1].asset_id],
            quality: "SP"
          })
        }
      }

      if (cartasEspeciaisCxAlto.length) {
        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: this.configuracoes.id_filtro_automatico_cx_alto,
          variar: this.configuracoes.preco_variacao_filtro_automatico_2,
          maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_alto ? this.configuracoes.preco_compra_carta_especial_cx_alto : TopSniperUtil.getMenorPreco(cartasEspeciaisCxAlto[0].valor_all),
          maskedDefId: [cartasEspeciaisCxAlto[0].asset_id],
          quality: "SP"
        })
      }
    }

    public async processarTopCartasPilotoPrincipalPorRaridade(cartasEspeciaisCxMedio: ICartaTopSniper[], cartasEspeciaisCxAlto: ICartaTopSniper[]) {
      if (cartasEspeciaisCxMedio.length) {
        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: this.configuracoes.id_filtro_automatico_cx_medio_1,
          variar: this.configuracoes.preco_variacao_filtro_automatico_2,
          maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_medio ? this.configuracoes.preco_compra_carta_especial_cx_medio : TopSniperUtil.getMenorPreco(cartasEspeciaisCxMedio[0].valor_all),
          maskedDefId: [cartasEspeciaisCxMedio[0].asset_id],
          rarity: [cartasEspeciaisCxMedio[0].raridade.id]
        })
        if (cartasEspeciaisCxMedio.length > 1) {
          TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
            id: this.configuracoes.id_filtro_automatico_cx_medio_2,
            variar: this.configuracoes.preco_variacao_filtro_automatico_2,
            maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_medio ? this.configuracoes.preco_compra_carta_especial_cx_medio : TopSniperUtil.getMenorPreco(cartasEspeciaisCxMedio[1].valor_all),
            maskedDefId: [cartasEspeciaisCxMedio[1].asset_id],
            rarity: [cartasEspeciaisCxMedio[1].raridade.id]
          })
        }
      }

      if (cartasEspeciaisCxAlto.length) {
        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: this.configuracoes.id_filtro_automatico_cx_alto,
          variar: this.configuracoes.preco_variacao_filtro_automatico_2,
          maxBuyNow: this.configuracoes.preco_compra_carta_especial_cx_alto ? this.configuracoes.preco_compra_carta_especial_cx_alto : TopSniperUtil.getMenorPreco(cartasEspeciaisCxAlto[0].valor_all),
          maskedDefId: [cartasEspeciaisCxAlto[0].asset_id],
          rarity: [cartasEspeciaisCxAlto[0].raridade.id]
        })
      }
    }

    //METODOS ADMIN DIEGOOOOOL
    private async metodoTopCartasAdminDiego() {
      let cartasQualidadeEspeciaiscartasEspeciaisCxMedio: ICartaTopSniper[] = []
      let cartasQualidadeEspeciaiscartasEspeciaisCxAlto: ICartaTopSniper[] = []
      let porcentagemLucro = 0.2; //10% de lucro
      let precoFutbin = 15000;

      let cartasCxBaixo: ICartaTopSniper[] = this.topCartasMomento.filter((ele: any) => {
        console.log('nome: ', ele.nome, 'valor:', ele.valor, 'preço futbin:', ele.preco);
        console.log('CARTAS CAIXA BAIXO', ele.raridade.id == 1 && ele.valor <= this.configuracoes.preco_compra_carta_especial_cx_baixo && ele.preco > precoFutbin);
        return ele.raridade.id >= 1 && ele.valor <= this.configuracoes.preco_compra_carta_especial_cx_baixo && ele.preco > precoFutbin;
      });

      let cartasEspeciaisCxMedio: ICartaTopSniper[] = this.topCartasMomento.filter((ele: any) => {
        // raridade acima de ouro >>> ele.raridade.id > 1
        // valor do filtro tem que ser maior do que o valor que esta caindo >>> this.configuracoes.preco_compra_carta_especial_cx_medio > ele.valor
        // o preço da carta caindo retira 15%, o resultado tem que ser mais do que o valor do filtro ele.preco - (ele.preco * 0.15) > this.configuracoes.preco_compra_carta_especial_cx_medio
        //console.log('CARTAS CAIXA MEDIO', ele.raridade.id >= 1 && (this.configuracoes.preco_compra_carta_especial_cx_medio > ele.valor) && (ele.preco - (ele.preco * porcentagemLucro) > this.configuracoes.preco_compra_carta_especial_cx_medio));
        return ele.raridade.id >= 1 && (this.configuracoes.preco_compra_carta_especial_cx_medio > ele.valor) && (ele.preco - (ele.preco * porcentagemLucro) > this.configuracoes.preco_compra_carta_especial_cx_medio);
      });

      let cartasEspeciaisCxAlto: ICartaTopSniper[] = this.topCartasMomento.filter((ele: any) => {
        //console.log('CARTAS CAIXA ALTO', ele.raridade.id >= 1 && (this.configuracoes.preco_compra_carta_especial_cx_alto > ele.valor) && (ele.preco - (ele.preco * porcentagemLucro) > this.configuracoes.preco_compra_carta_especial_cx_alto));
        return ele.raridade.id >= 1 && (this.configuracoes.preco_compra_carta_especial_cx_alto > ele.valor) && (ele.preco - (ele.preco * porcentagemLucro) > this.configuracoes.preco_compra_carta_especial_cx_alto);
      });

      // console.log('CARTASOURO:: ', cartasCxBaixo);
      // console.log('CARTASESPECIAISMEDIO:: ', cartasEspeciaisCxMedio);
      // console.log('CAIXA ALTO:: ', cartasEspeciaisCxAlto);

      if (this.configuracoes.usar_filtro_qualidade) {
        cartasQualidadeEspeciaiscartasEspeciaisCxMedio = await TopSniperUtil.filtrarCartasQualidadeEspecialCompativelFiltro(cartasEspeciaisCxMedio, this.configuracoes.preco_variacao_filtro_automatico_2)
        cartasQualidadeEspeciaiscartasEspeciaisCxAlto = await TopSniperUtil.filtrarCartasQualidadeEspecialCompativelFiltro(cartasEspeciaisCxAlto, this.configuracoes.preco_variacao_filtro_automatico_2)
      }

      if (cartasCxBaixo.length) {
        const config = this.configuracoes;
        const maxBuyNow = config.preco_compra_carta_especial_cx_baixo ? config.preco_compra_carta_especial_cx_baixo : TopSniperUtil.getMenorPreco(cartasCxBaixo[0].valor_all);
        const assetIds = [cartasCxBaixo[0].asset_id];

        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: config.id_filtro_automatico_cx_baixo,
          variar: config.preco_variacao_filtro_automatico_1,
          maxBuyNow: maxBuyNow,
          maskedDefId: assetIds,
          rarity: [cartasCxBaixo[0].raridade.id]
        });

        // if (cartasCxBaixo.length > 1) {
        //   assetIds.push(cartasCxBaixo[1].asset_id);

        //   TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
        //     id: config.id_filtro_automatico_cx_baixo,
        //     variar: config.preco_variacao_filtro_automatico_1,
        //     maxBuyNow: maxBuyNow,
        //     maskedDefId: assetIds,
        //     rarity: [cartasCxBaixo[0].raridade.id]
        //   });
        // }
      }

      if (this.configuracoes.usar_filtro_qualidade) {
        this.processarTopCartasPilotoPrincipalPorQualidade(cartasQualidadeEspeciaiscartasEspeciaisCxMedio, cartasQualidadeEspeciaiscartasEspeciaisCxAlto)
      } else {
        this.processarTopCartasPilotoPrincipalPorRaridade(cartasEspeciaisCxMedio, cartasEspeciaisCxAlto)
      }
    }
    //##########
  }
}
